import { NgModule } from '@angular/core';
import { BootstrapIconsModule } from 'ng-bootstrap-icons';
import {
	Check,
	CheckCircleFill,
	Circle,
	ExclamationCircle,
	ExclamationTriangle,
	InfoCircle,
	Trash
} from 'ng-bootstrap-icons/icons';

// Icons die von den Controls benötigt werden
const icons = {
	Check,
	CheckCircleFill,
	Circle,
	ExclamationCircle,
	ExclamationTriangle,
	InfoCircle,
	Trash
};

@NgModule({
	imports: [
		BootstrapIconsModule.pick(icons)
	],
	exports: [
		BootstrapIconsModule
	]
})
export class ControlsIconsModule { }
